import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetRestaurantTransferCommentsApi } from './use-get-restaurant-transfer-comments-api';

const endpoint = 'oms/v1/restaurant-transfers';
export const createRestaurantTransferCommentEndpointIdentifier = endpoint;

interface BodyType {
  text: string;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  restaurantTransferId: string;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCreateRestaurantTransferCommentApi(restaurantTransferId: string, options?: Options): ReturnType {
  const { refetch: refetchRestaurantTransferCommentsApi } = useGetRestaurantTransferCommentsApi(restaurantTransferId, {
    enabled: false,
  });

  const toast = useCustomToast();

  const mutationFn = async ({ restaurantTransferId, body }: TVariables) => {
    try {
      const { data } = await http.post(endpoint + `/${restaurantTransferId}/comments`, body);

      // Re-fetch restaurant transfer comments list
      refetchRestaurantTransferCommentsApi();

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
